import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterLink } from '@angular/router';
import { Bau365DataAccessFairDataModule } from '@planone/bau365/data-access-fair-data';
import { Bau365FeatureBreadcrumbModule } from '@planone/bau365/feature-breadcrumb';
import { Bau365FeatureUserProfileSharedModule } from '@planone/bau365/feature-user-profile';
import { Bau365FeatureWatchlistSharedModule } from '@planone/bau365/feature-watchlist';
import { Bau365UiDateformattingModule } from '@planone/bau365/ui-dateformatting';
import { SharedDataAccessSwiperModule } from '@planone/shared/data-access-swiper';
import { SharedUiElementsModule } from '@planone/shared/ui-elements';
import { SharedUtilPipelinesModule } from '@planone/shared/util-pipelines';
import { SharedUiSwiperModule } from '@planone/shared-feature-swiper';

import { EventCardComponent } from './event-card/event-card.component';
import { EventCardListComponent } from './event-card-list/event-card-list.component';
import { SectionActionsComponent } from './page-event-details/section-actions/section-actions.component';
import { SectionContactComponent } from './page-event-details/section-contact/section-contact.component';
import { SectionContributorsComponent } from './page-event-details/section-contributors/section-contributors.component';
import { SectionDetailsComponent } from './page-event-details/section-details/section-details.component';
import { SectionDeviderComponent } from './page-event-details/section-devider/section-devider.component';
import { SectionEntityListComponent } from './page-event-details/section-entity-list/section-entity-list.component';
import { SectionHeaderComponent } from './page-event-details/section-header/section-header.component';
import { SectionInfoComponent } from './page-event-details/section-info/section-info.component';

@NgModule({
  imports: [
    CommonModule,
    SharedUiElementsModule,
    Bau365DataAccessFairDataModule,
    Bau365FeatureBreadcrumbModule,
    Bau365FeatureWatchlistSharedModule,
    Bau365FeatureUserProfileSharedModule,
    MatIconModule,
    SharedUtilPipelinesModule,
    Bau365UiDateformattingModule,
    SharedDataAccessSwiperModule,
    SharedUiSwiperModule,
    MatTabsModule,
    MatButtonModule,
    MatChipsModule,
    RouterLink,
  ],
  declarations: [
    EventCardComponent,
    EventCardListComponent,
    SectionHeaderComponent,
    SectionDetailsComponent,
    SectionInfoComponent,
    SectionDeviderComponent,
    SectionActionsComponent,
    SectionContactComponent,
    SectionContributorsComponent,
    SectionEntityListComponent,
  ],
  exports: [
    EventCardComponent,
    EventCardListComponent,
    SectionHeaderComponent,
    SectionDetailsComponent,
    SectionInfoComponent,
    SectionDeviderComponent,
    SectionActionsComponent,
    SectionContactComponent,
    SectionContributorsComponent,
    SectionEntityListComponent,
  ],
})
export class Bau365FeatureEventsSharedModule {}
